import { useState } from 'react';
import { useApp } from '../app-context';
import { TSPage } from '../components/commons';
import { DashService } from '../services/DashService';
import { Utils } from '../Utils';

import './LoginPage.scss';

const LoginPage = function ({ name, pageState }) {
    const [, dispatcher] = useApp();

    const [stateError, setStateError] = useState();
    const [stateBusy, setStateBusy] = useState(false);

    const handleBack = (e) => {
        Utils.displaySimpleYNQuestion(dispatcher, {
            content: "בטוח שברצונך לצאת מהאזור האישי?",
            onYes: (e) => {
                window.location.href = "https://chayuta.com";
            }
        })
    };

    const hadnleSubmit = (e) => {
        e.preventDefault();
        if (stateBusy) return;

        setStateError(undefined);
        if (!document.getElementById("loginTel").value || !document.getElementById("loginPid").value) {
            setStateError("חובה להזין את מספר הטלפון איתו נרשמת לביטוח ואת תעודת הזהות של בעל הפוליסה");
            return;
        }

        const loginMethod = (e.currentTarget.id === 'activationCode') ? 'phone' : 'sms';
        setStateBusy(true);
        DashService.requestLoginCode(document.getElementById("loginTel").value, document.getElementById("loginPid").value, loginMethod)
            .then((data) => {
                dispatcher({ action: "setLoginKey", params: { key: data.key, phone: document.getElementById("loginTel").value, pid: document.getElementById("loginPid").value, method: loginMethod }});
                dispatcher({ action: "showPage", params: { id: "loginPin" } });
            })
            .catch(ex => {
                setStateError(ex?.message || "מצטערים, לא ניתן לבצע את הפעולה המבוקשת במועד זה");
            })
            .finally(() => {
                setStateBusy(false);
            });
    };

    return (
        <TSPage name={name} pageState={pageState} className="fading">
            <img className="bg full" src="/img/login/bg.svg" alt="" />
            <img className="bg" src="/img/login/back-elements.svg" alt="" />
            <img className="bg front" src="/img/login/front-elements.svg" alt="" />

            <div className="content">
                <form onSubmit={hadnleSubmit}>
                    <button type="button" className="backBtn" onClick={handleBack}>
                        <img src="/img/close.svg" alt="back" />
                    </button>
                    <h1 className="header">חלק ממשפחת חיותא?</h1>
                    <h5 className="subHeader">כמה פרטים ואתם מחוברים</h5>
                    <div className="field">
                        <input id="loginTel" type="tel" placeholder="מספר טלפון"/>
                    </div>
                    <div className="field">
                        <input id="loginPid" type="text" inputMode="numeric" placeholder="תעודת זהות" />
                    </div>
                    { stateError ?
                        <div className="error-msg">
                            {stateError}
                        </div>
                    : undefined }
                    <div><button className="yellow submit">לקבלת קוד זיהוי ב- SMS</button></div>
                    <div className="activationCode"><a id='activationCode' href="#" onClick={hadnleSubmit}>שלחו לי קוד בשיחת טלפון</a></div>
                </form>
            </div>
        </TSPage>
    );
}

export { LoginPage };